// extracted by mini-css-extract-plugin
module.exports = {"container":"TagClose_container__e9fe8","sm":"TagClose_sm__3RRcl","md":"TagClose_md__wfhLU","lg":"TagClose_lg__3Y25W","sending":"TagClose_sending__2VWT5"};